import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

class Footer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        let administradoraSeleccionadaId =  this.props.data.base.administradoraSeleccionadaId;

        if (parseInt(administradoraSeleccionadaId) > 0) {
            let administradora = this.props.data.base.administradora.find(x => x.Id == administradoraSeleccionadaId);
            this.props.routeTipoEmpresa(administradora);
        }
        else {
            this.props.showError();
        }
    }

    cancelClick() {
        this.props.routeToCancel();
    }

    routeToVistaCliente() {
        this.props.routeToVistaCliente();
    }

    render() {
        const { routeToVistaCliente } = this.props;
        let cancelButton = <button onClick={() => this.routeToVistaCliente()} className="btn btn-secondary">Cancelar</button>

        return (
            <div className="row">
                <div className="col-md-2">
                    {cancelButton}
                </div>
                <div className="col-md-4">
                </div>
                <div className="col-md-4">
                </div>
                {this.props.permisos.components.BotonesAnteriorSiguiente.Active == true &&
                    <div className="col-md-2">
                        <GenericSimpleButton text="Siguiente >" buttonClass="btn btn-cta float-right" onClick={this.handleClick} />
                    </div>}
            </div>
        );
    }
};

export default Footer